import { matchPath } from 'react-router-dom';
import { PUBLIC_PATHS, SKIP_AUTH_REDIRECT_PATHS } from 'routes/routesRegistry';

export { PUBLIC_PATHS, SKIP_AUTH_REDIRECT_PATHS };

export const isPublicPath = (pathname: string): boolean =>
  PUBLIC_PATHS.some(p => matchPath({ path: p, end: false }, pathname) !== null);

export const shouldSkipAuthRedirect = (pathname: string): boolean =>
  SKIP_AUTH_REDIRECT_PATHS.some(
    p => matchPath({ path: p, end: false }, pathname) !== null,
  );
